module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/16bc89960360c58e0f8212b8a1eb94f0.png";